/** Formats PDP prices with correct currency symbol and fractional cents when needed. */
const formatProgramPrice = (
  price: number = 0,
  currency: string = "USD",
): string => {
  const hasDecimal = price % 1 !== 0;

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: 2,
    minimumFractionDigits: hasDecimal ? 2 : 0,
  }).format(price);
};

export default formatProgramPrice;
